import React, { Component } from 'react';
import PropTypes from 'prop-types';
import srcDoc from 'srcdoc-polyfill';

const framePadding = 100;

export default class DocumentFrame extends Component {
    static propTypes = {
        document: PropTypes.object.isRequired,
        body: PropTypes.string.isRequired,
    };

    componentDidMount() {
        const { body } = this.props;

        if (body) {
            srcDoc.set(this.frame, body.replace(/["]/g, '\''));
        }
    }

    setHeight = () => {
        const frameHeight = this.frame.contentWindow.document.body.scrollHeight + framePadding;
        this.frame.style.height = frameHeight + 'px';
    }

    render() {
        return (
            <iframe
                title="1frame"
                className="iframe-document preview-paddings"
                ref={node => this.frame = node}
                onLoad={this.setHeight}
            />
        );
    }
}
